import { Unit } from "./Unit";
import { UnitGroup } from "./UnitGroup";

export class TemperatureUnits extends UnitGroup {
    private static _singleton: TemperatureUnits;

    public static readonly CELSIUS = new Unit("C", "Celsius");
    public static readonly FAHRENHEIT = new Unit("F", "Fahrenheit");
    
    constructor() {
        const units = [ TemperatureUnits.CELSIUS, TemperatureUnits.FAHRENHEIT ];
        super(units, "temperature_company_um", "temperature_functional_um");
    }

    public static get singleton(): TemperatureUnits {
        if (this._singleton == null) {
            this._singleton = new TemperatureUnits();
        }
        return this._singleton;
    }
}
